window.addEventListener("load", () => {
  // ウィンドウサイズを取得
  const windowWidth = window.innerWidth;
  // 地域ごとのショップリストを回す
  const shopLists = document.querySelectorAll(".shoplist-main__shop__list");
  shopLists.forEach((shopList) => {
    // ショップリストごとののショップタイトルを取得し回す
    const shopTitles = shopList.querySelectorAll(
      ".shoplist-main__shop__item h5"
    );
    shopTitles.forEach((shopTitle, index) => {
      // SPの場合、2つの高さを比べる
      if (windowWidth < 749) {
        if ((index + 1) % 2 !== 0) {
          const heightArray = [];
          const currentTitleHeight = shopTitle.clientHeight;

          // 2つの目の高さ取得
          let nextTitleHeight = "";
          if (shopTitles[index + 1]) {
            nextTitleHeight = shopTitles[index + 1].clientHeight;
          }

          // 取得した高さを配列に入れる
          heightArray.push(Number(currentTitleHeight));
          heightArray.push(Number(nextTitleHeight));

          // 一番高かった高さを設定する
          const heightMax = Math.max(...heightArray);
          shopTitle.style.minHeight = `${heightMax}px`;
          if (shopTitles[index + 1]) {
            shopTitles[index + 1].style.minHeight = heightMax;
          }
        }
        // PCの場合、4つの高さを比べる
      } else {
        if ((index + 1) % 5 == 0 || index == 0) {
          const heightArray = [];
          const currentTitleHeight = shopTitle.clientHeight;

          // 2つの目の高さ取得
          let secondTitleHeight = "";
          if (shopTitles[index + 1]) {
            secondTitleHeight = shopTitles[index + 1].clientHeight;
          }

          // 3つの目の高さ取得
          let thirdTitleHeight = "";
          if (shopTitles[index + 2]) {
            thirdTitleHeight = shopTitles[index + 2].clientHeight;
          }

          // 4つの目の高さ取得
          let fourthTitleHeight = "";
          if (shopTitles[index + 3]) {
            fourthTitleHeight = shopTitles[index + 3].clientHeight;
          }

          // 取得した高さを配列に入れる
          heightArray.push(Number(currentTitleHeight));
          heightArray.push(Number(secondTitleHeight));
          heightArray.push(Number(thirdTitleHeight));
          heightArray.push(Number(fourthTitleHeight));

          // 一番高かった高さを設定する
          const heightMax = Math.max(...heightArray);
          shopTitle.style.minHeight = `${heightMax}px`;
          if (shopTitles[index + 1]) {
            shopTitles[index + 1].style.minHeight = `${heightMax}px`;
          }
          if (shopTitles[index + 2]) {
            shopTitles[index + 2].style.minHeight = `${heightMax}px`;
          }
          if (shopTitles[index + 3]) {
            shopTitles[index + 3].style.minHeight = `${heightMax}px`;
          }
        }
      }
    });
  });
});

window.addEventListener("resize", () => {
  // ウィンドウサイズを取得
  const windowWidth = window.innerWidth;
  // 地域ごとのショップリストを回す
  const shopLists = document.querySelectorAll(".shoplist-main__shop__list");
  shopLists.forEach((shopList) => {
    // ショップリストごとののショップタイトルを取得し回す
    const shopTitles = shopList.querySelectorAll(
      ".shoplist-main__shop__item h5"
    );
    shopTitles.forEach((shopTitle, index) => {
      if (windowWidth < 749) {
        if ((index + 1) % 2 !== 0) {
          const heightArray = [];
          const currentTitleHeight = shopTitle.clientHeight;

          let nextTitleHeight = "";
          if (shopTitles[index + 1]) {
            nextTitleHeight = shopTitles[index + 1].clientHeight;
          }

          heightArray.push(Number(currentTitleHeight));
          heightArray.push(Number(nextTitleHeight));

          const heightMax = Math.max(...heightArray);
          shopTitle.style.minHeight = `${heightMax}px`;
          if (shopTitles[index + 1]) {
            shopTitles[index + 1].style.minHeight = `${heightMax}px`;
          }
        }
      } else {
        if ((index + 1) % 5 == 0 || index == 0) {
          const heightArray = [];
          const currentTitleHeight = shopTitle.clientHeight;

          // 2つの目の高さ取得
          let secondTitleHeight = "";
          if (shopTitles[index + 1]) {
            secondTitleHeight = shopTitles[index + 1].clientHeight;
          }

          // 3つの目の高さ取得
          let thirdTitleHeight = "";
          if (shopTitles[index + 2]) {
            thirdTitleHeight = shopTitles[index + 2].clientHeight;
          }

          // 4つの目の高さ取得
          let fourthTitleHeight = "";
          if (shopTitles[index + 3]) {
            fourthTitleHeight = shopTitles[index + 3].clientHeight;
          }

          // 取得した高さを配列に入れる
          heightArray.push(Number(currentTitleHeight));
          heightArray.push(Number(secondTitleHeight));
          heightArray.push(Number(thirdTitleHeight));
          heightArray.push(Number(fourthTitleHeight));

          // 一番高かった高さを設定する
          let heightMax = 0;
          heightMax = Math.max(...heightArray);
          shopTitle.style.minHeight = `${heightMax}px`;
          if (shopTitles[index + 1]) {
            shopTitles[index + 1].style.minHeight = `${heightMax}px`;
          }
          if (shopTitles[index + 2]) {
            shopTitles[index + 2].style.minHeight = `${heightMax}px`;
          }
          if (shopTitles[index + 3]) {
            shopTitles[index + 3].style.minHeight = `${heightMax}px`;
          }
        }
      }
    });
  });
});
